<script>
    export let line;
</script>

<style lang="less">
    @import "./common.less";
    h1:first-child, h2:first-child, h3:first-child, p:first-child {
        margin-top: 0px;
    }
    h1, h2, h3 {
        white-space: pre-wrap;
        font-family: oswald;
        font-weight: normal;
        margin: 20px 0 0 0;
    }
    h1 {
        margin: 30px 0;
    }
    h1 {
        font-size: 30px;
        text-transform: uppercase;
        color: @brightFg;
    }
    h2 {
        font-size: 25px;
        text-transform: uppercase;
    }
    h3 {
        font-size: 20px;
    }
    p {
        margin: 10px 0 0 0;
        white-space: pre-wrap;
    }
    .small {
        font-size: 70%;
        font-style: italic;
    }
    .tagline {
        margin-top: -23px;
    }
    .centered {
        text-align: center;
    }
    .underlined {
        text-decoration: underline;
        margin-bottom: 2px;
    }
    .underlined + :global(p) {
        margin-top: 2px;
    }
    .zoom {
        animation: zoom-frames 1s ease-in-out;
    }

    @keyframes zoom-frames {
        0% {
            transform: scale(0.01);
        }
        100% {
            transform: scale(1.0);
        }
    }
</style>

{#if line.tag === 'h1'}
    <h1 class:zoom={line.zoom} on:animationend={(e) => e.target.classList.remove('zoom')} class="{line.classes}"><slot/></h1>
{:else if line.tag === 'h2'}
    <h2 class:zoom={line.zoom} on:animationend={(e) => e.target.classList.remove('zoom')} class="{line.classes}"><slot/></h2>
{:else if line.tag === 'h3'}
    <h3 class:zoom={line.zoom} on:animationend={(e) => e.target.classList.remove('zoom')} class="{line.classes}"><slot/></h3>
{:else}
    <p class:zoom={line.zoom} on:animationend={(e) => e.target.classList.remove('zoom')} class="{line.classes}"><slot/></p>
{/if}
